import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info-section-tutorial" }
const _hoisted_2 = { class: "info-section-tutorial__title font-weight-medium" }
const _hoisted_3 = { class: "info-section-tutorial__tiles" }

import type { Tutorial } from '@/types';
import InfoSectionTutorialTile from './InfoSectionTutorialTile.vue';

type Props = {
  tutorialTiles: Tutorial[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionTutorial',
  props: {
    tutorialTiles: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('thanks.infoSection.howToMake')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tutorialTiles, (tutorial, index) => {
        return (_openBlock(), _createBlock(InfoSectionTutorialTile, {
          key: index,
          title: tutorial.title,
          text: tutorial.text,
          link: tutorial.link,
          icon: tutorial.icon
        }, null, 8, ["title", "text", "link", "icon"]))
      }), 128))
    ])
  ]))
}
}

})